import { CHECKBOX_STATUS } from 'ui/checkbox/checkboxStatus';
import { FolderClosed } from 'ui/icons';
import { FolderRow } from 'ui/indexPages/folders/folderRow';
import { CheckboxGridCell } from 'ui/indexPages/tables/cells';
import { useSelectionContext } from '../../../contexts/SelectionContext';

import { AssetSubfolder } from 'modules/creativeLibrary/types';
import { SearchParamLink } from 'ui/utility/SearchParamLink/SearchParamLink';
import { FOLDER_ID_SEARCH_PARAM, PAGE_SEARCH_PARAM } from 'modules/creativeLibrary/constants';
import { FolderActionMenu } from '../common/FolderActionMenu';
import { isSelectionFolder } from 'utils/contexts/selection';

export const TableFolderRow = ({
  folder,
  isPanel,
  hasManageBaseTemplatesPermission,
}: {
  folder: AssetSubfolder;
  isPanel: boolean;
  hasManageBaseTemplatesPermission: boolean;
}) => {
  const { id, name } = folder;
  const { bulk, toggleBulkSelection } = useSelectionContext();
  const isSelected =
    bulk.findIndex((selected) => isSelectionFolder(selected) && selected.id === id) > -1;

  return (
    <FolderRow id={id.toString()}>
      {isPanel || !hasManageBaseTemplatesPermission ? (
        <div />
      ) : (
        <CheckboxGridCell
          handleClick={() => toggleBulkSelection(folder)}
          id={id.toString()}
          status={isSelected ? CHECKBOX_STATUS.CHECKED : CHECKBOX_STATUS.UNCHECKED}
        />
      )}

      <FolderClosed data-test="folder-icon" />

      <SearchParamLink
        searchParams={{
          [FOLDER_ID_SEARCH_PARAM]: id.toString(),
        }}
        deleteSearchParams={[PAGE_SEARCH_PARAM]}
      >
        {name}
      </SearchParamLink>
      {!isPanel && hasManageBaseTemplatesPermission && <FolderActionMenu folder={folder} />}
    </FolderRow>
  );
};
